module.exports = __webpack_public_path__ + "static/media/advertisers_section1.74901e69.png";